(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["uk-product-copy"] && !Shopify.designMode) return;
  try {
    const stripNode = (node) => {
    if (!(node instanceof Element)) return;
    const wrap = node.closest('p, span, div, figure, picture') || node;
    node.remove();
    if (wrap.isConnected && !wrap.textContent.trim() && wrap.children.length === 0) wrap.remove();
  };

  document.querySelectorAll('.uk-pdp-copy__details img, .uk-pdp-copy__details picture, .uk-pdp-copy__details figure, .uk-pdp-copy__details table').forEach(stripNode);

  document.querySelectorAll('.uk-pdp-copy__details p, .uk-pdp-copy__details h2, .uk-pdp-copy__details h3, .uk-pdp-copy__details h4, .uk-pdp-copy__details strong').forEach((el) => {
    const text = (el.textContent || '').trim();
    if (/^size\s*charts?$/i.test(text) || /^size\s*guide$/i.test(text)) el.remove();
  });
  } catch(e) { console.error(e); }
})();

})();
